class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-queue-presence`;
    }
    /**
     * Returns a list of agent's call queues with the agent presence status (per queue).
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-queue-presence
     * Rate Limit Group: Light
     * App Permission: ReadPresence
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates availability of the agent for the call queues.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-queue-presence
     * Rate Limit Group: Medium
     * App Permission: EditPresence
     */
    async put(extensionCallQueueUpdatePresenceList, restRequestConfig) {
        const r = await this.rc.put(this.path(), extensionCallQueueUpdatePresenceList, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
